<div>Welcome {{ userService.simpleName$ | async }},&nbsp;</div>
<div>
  @for (greeting of greetingMessage; track $index) {
    <span cycle [class]="(classes$ | async)?.[$index]">
      <span aria-hidden="true">{{ greeting }}</span>
    </span>
  }
</div>
